type Page01HeroProps = {
  onNavigate: (scene: number) => void;
  onAssessment: () => void;
};

export function Page01Hero({ onNavigate, onAssessment }: Page01HeroProps) {
  return (
    <main className="page01-hero">
      <img className="page01-photo" src="/assets/page01-summit.jpg" alt="A lone man above a mountain ridge at altitude" fetchPriority="high" />
      <div className="page01-grade" aria-hidden="true" />

      <p className="page01-tagline">TRAINING FOR MEN WHO REFUSE TO<br />LET LIFE BET THE TERMS.</p>
      <h1>BECOME THE HOUSE</h1>
      <div className="page01-body-copy">
        <span>Right now the sportsbook has the edge on you.</span>
        <span>The lines. The math. The speed.</span>
        <span>But that edge isn’t permanent.</span>
        <span>You can build your own.</span>
        <span>Own the process. Own your decisions.</span>
        <span>Become the House.</span>
      </div>

      <div className="page01-actions" aria-label="Get started">
        <button className="site-button site-button-primary" type="button" onClick={onAssessment}>
          BEGIN THE PRIVATE ASSESSMENT
        </button>
        <button className="site-button site-button-secondary" type="button" onClick={() => onNavigate(6)}>
          SEE HOW HOUSE 45 WORKS
        </button>
      </div>
    </main>
  );
}
